<!--CFS > Scan Load-->
<template>
  <div>
    <a-drawer :title="$t('cfs.scanLoad')+ '('+ loadingNo + ')'" @close="onClose" :visible="visible" width="95%" :maskClosable="false">
      <a-row :gutter="10" style="margin: 10px 0 0 0;text-align: right;">
        <a-col v-show="this.consolidationHandling=='ORIGIN'" span="4">
          <div class="scanpackHeader">
            <div class="searchTitle">{{cfsScanLoad == 'Y' ? 'HAWB#' : $t('cfs.awbMbl') }}:</div>
            <a-input style="width: 100%;"
                     ref="relIdRef"
                     :placeholder="$t('publicLang.PleaseEnter')"
                     v-model="awbMbl"
                     size="small"
                     @pressEnter="searchScanLoad"/>
          </div>
        </a-col>
        <a-col v-show="this.consolidationHandling=='ORIGIN' && 1 == 2" span="4">
          <div class="scanpackHeader">
            <div class="searchTitle">{{$t('flightNo')}}:</div>
            <a-input
                    :placeholder="$t('publicLang.PleaseEnter')"
                    v-model="flightNo"
                    size="small"
                    @pressEnter="searchScanLoad"/>
          </div>
        </a-col>
        <a-col v-show="this.consolidationHandling=='ORIGIN' && cfsScanLoad != 'Y'" span="4">
          <div class="scanpackHeader">
            <div class="searchTitle">{{$t('cfs.uldNo') }}:</div>
            <a-input
                    :placeholder="$t('publicLang.PleaseEnter')"
                    v-model="uldNo"
                    size="small"
                    @pressEnter="searchScanLoad"/>
          </div>
        </a-col>
        <a-col v-show="this.consolidationHandling=='ORIGIN' && 1 == 2" span="4">
          <div class="scanpackHeader">
            <div class="searchTitle">{{$t('airLine')}}:</div>
            <a-select v-model="uldNo" style="width: 100%;" size="small" :placeholder="$t('publicLang.PleaseSelect')">
              <a-select-option v-for="item in localData.SKYNET_CARRIER" :value="item.CODE">
                {{item.CODE_DESC}}
              </a-select-option>
            </a-select>
          </div>
        </a-col>
        <a-col span="4">
          <div class="scanpackHeader">
            <div class="searchTitle">{{ $t('cfs.loadingNo') }}:</div>
            <a-input
                    :placeholder="$t('publicLang.PleaseEnter')"
                    v-model="loadingNo"
                    :disabled="!showQuery"
                    size="small"
                    @pressEnter="searchScanLoad"/>
          </div>
        </a-col>
      </a-row>
      <a-row :gutter="10" type="flex" justify="start" style="margin: 10px 0 0 0;text-align: right;" v-if="this.consolidationHandling=='ORIGIN' && cfsScanLoad == 'Y'">
        <a-col span="4">
          <div class="scanpackHeader">
            <div class="searchTitle">Gateway:</div>
            <a-select v-model="gateWay" style="width: 100%;" size="small" :placeholder="$t('publicLang.PleaseSelect')">
              <a-select-option v-for="item in localData.SKYNET_GATEWAY" :value="item.CODE">
                {{item.CODE_DESC}}
              </a-select-option>
            </a-select>
          </div>
        </a-col>
        <a-col span="4">
          <div class="scanpackHeader">
            <div class="searchTitle">{{$t('services')}}:</div>
            <a-select v-model="service" style="width: 100%;" size="small" :placeholder="$t('publicLang.PleaseSelect')">
              <a-select-option v-for="item in localData.SKYNET_SERVICE" :value="item.CODE">
                {{item.CODE_DESC}}
              </a-select-option>
            </a-select>
          </div>
        </a-col>
        <a-col span="4">
          <div class="scanpackHeader">
            <div class="searchTitle">{{$t('servicesProvider')}}:</div>
            <a-select v-model="servicesProvider" style="width: 100%;" size="small" :placeholder="$t('publicLang.PleaseSelect')">
              <a-select-option v-for="item in localData.SKYNET_SERVICE_PROVIDER" :value="item.CODE">
                {{item.CODE_DESC}}
              </a-select-option>
            </a-select>
          </div>
        </a-col>
        <a-col span="4">
          <div class="scanpackHeader">
            <div class="searchTitle">{{$t('skynetPostal')}}:</div>
            <a-select v-model="skynetPostal" style="width: 100%;" size="small" :placeholder="$t('publicLang.PleaseSelect')">
              <a-select-option v-for="item in localData.SKYNET_POSTAL" :value="item.CODE">
                {{item.CODE_DESC}}
              </a-select-option>
            </a-select>
          </div>
        </a-col>
        <a-col span="4">
          <div class="scanpackHeader">
            <div class="searchTitle">{{$t('battery')}}:</div>
            <a-select v-model="battery" style="width: 100%;" size="small" :placeholder="$t('publicLang.PleaseSelect')">
              <a-select-option v-for="item in localData.BATTERY" :value="item.CODE">
                {{item.CODE_DESC}}
              </a-select-option>
            </a-select>
          </div>
        </a-col>
      </a-row>
      <a-row type="flex" justify="start" style="margin: 10px 0 0 0">
        <a-col v-show="this.consolidationHandling=='DESTINATION'">
          <div class="scanpackHeader">
            <div class="searchTitle" style="text-align: right; width: 150px">{{ $t('cfs.collectionTimeFrom') }}:</div>
            <a-date-picker
                    :placeholder="$t('publicLang.PleaseSelect')"
                    format="YYYY-MM-DD HH:mm"
                    size="small"
                    show-time
                    v-model="collectionTimeFrom"
                    @change="changeCollectionTimeFrom"
                    :disabled-date="disabledDateFrom"/>
          </div>
        </a-col>
        <a-col v-show="this.consolidationHandling=='DESTINATION'">
          <div class="scanpackHeader">
            <div class="searchTitle" style="text-align: right; width: 150px">{{ $t('cfs.collectionTimeTo') }}:</div>
            <a-date-picker
                    :placeholder="$t('publicLang.PleaseSelect')"
                    format="YYYY-MM-DD HH:mm"
                    size="small"
                    show-time
                    v-model="collectionTimeTo"
                    @change="changeCollectionTimeTo"
                    :disabled-date="disabledDateTo"/>
          </div>
        </a-col>
        <a-col style="margin-left: 20px;">
          <a-button v-if="showQuery" size="small" type="primary" @click="searchScanLoad">
            {{ $t('generic.Searchable') }}
          </a-button>
          <a-button v-else size="small" type="primary" @click="reset">
            {{ $t('job.Reset') }}
          </a-button>
        </a-col>
        <a-col style="margin-left: 20px;">
          <a-button v-if="showCreate" size="small" type="primary" @click="createLoading">
            {{ $t('cfs.createLoading') }}
          </a-button>
          <a-button v-else size="small" type="primary" @click="confirmLoading">
            {{ $t('cfs.confirmLoading') }}
          </a-button>
        </a-col>
        <a-col style="margin-left: 20px;" v-show="this.loadingNo != null && this.loadingNo != ''">
          <a-button size="small" type="primary" @click="saveLoading">
            {{ $t('userlang.Save') }}
          </a-button>
        </a-col>
        <template v-if="this.consolidationHandling=='ORIGIN' && cfsScanLoad == 'Y'">
          <a-col style="margin-left: 20px;" >
            <a-button size="small" type="primary" @click="printViewPdf">
              {{ $t('cfs.printViewPdf') }}
            </a-button>
          </a-col>
          <a-col style="margin-left: 20px;" v-show="this.loadingNo != null && this.loadingNo != ''">
            <a-button size="small" type="primary" @click="copyLoading">
              {{ $t('copyLoading') }}
            </a-button>
          </a-col>
        </template>
      </a-row>
      <a-divider style="margin: 10px 0"></a-divider>

      <a-row>
        <vxe-table
                border
                :data.sync="tableList"
                ref="skuTable"
                class="mytable-style"
                :cell-class-name="cellClassName"
                max-height="280"
                show-footer
                resizable
                :footer-method="footerMethod"
                :footer-cell-class-name="footerCellClassName"
                size="mini"
                :row-style="rowStyle"
        >
          <template v-slot:empty>
            <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
          </template>
          <vxe-table-column type="checkbox" width="50"></vxe-table-column>
          <vxe-table-column field="uldNo" :title="$t('cfs.uldNo')" show-header-overflow="ellipsis" show-overflow="ellipsis"></vxe-table-column>
          <vxe-table-column field="orderNo" :title="$t('cfs.platformOrderNo')" show-header-overflow="ellipsis" show-overflow="ellipsis"></vxe-table-column>
          <vxe-table-column field="parcelNo" :title="$t('cfs.parcelNo')" show-header-overflow="ellipsis" show-overflow="ellipsis"></vxe-table-column>
          <vxe-table-column field="trackingNo" :title="$t('cfs.trackingNo')" show-header-overflow="ellipsis" show-overflow="ellipsis"></vxe-table-column>
          <vxe-table-column field="scannedQty" :title="$t('cfs.scannedQty')" show-header-overflow="ellipsis" show-overflow="ellipsis"></vxe-table-column>
          <vxe-table-column field="ediSendFlag" :title="$t('cfs.ediSendFlag')" show-header-overflow="ellipsis" show-overflow="ellipsis"></vxe-table-column>
        </vxe-table>
      </a-row>

      <a-row class="mt">
        <!--左侧-->
        <a-col :span="12" style="marginTop:6px">
          <a-row>
            <a-form :form="form" class="ant-advanced-search-form">
              <a-row :gutter="24">
                <a-col :span="8" offset="1">
                  <a-form-item :label="$t('cfs.parcelNo')">
                    <a-input
                            ref="parcelNoRef"
                            style="width: 100%;"
                            v-model="parcelNo"
                            :placeholder="$t('publicLang.PleaseEnter')"
                            size="small"
                            :disabled="moreLoading"
                            @pressEnter="parcelNoEnterEvt"/>
                  </a-form-item>
                </a-col>
                <a-col :span="4">
                  <a-form-item :label="$t('pubGicSet.RemoveScanItem')">
                    <a-checkbox
                            :checked="DeleteChecked"
                            @change="DeleteChangeEvnt"
                    ></a-checkbox>
                  </a-form-item>
                </a-col>
                <a-col :span="4" v-if="cfsScanLoad == 'Y'">
                  <a-form-item :label="$t('userlang.Country')">
                    <div style="font-weight: bold;font-size: 36px;">{{$t(country)}}</div>
                  </a-form-item>
                </a-col>
                <a-col :span="8" v-if="cfsScanLoad == 'Y'">
                  <a-form-item :label="$t('generic.Type')">
                    <div style="font-weight: bold;font-size: 36px;">{{$t(type)}}</div>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="7" offset="2">
                  <a-form-item :label="$t('pubGicSet.Qty')">
                    <a-input
                            :disabled="lockChecked"
                            style="width: 100%;"
                            v-model="OtySaoNum"
                            :placeholder="$t('publicLang.PleaseEnter')"
                            size="small"
                            ref="SacnPackSaomaQtyNum"
                            @pressEnter="qtyEnterEvt"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="5">
                  <a-form-item :label="$t('pubGicSet.LockScanQty')">
                    <a-checkbox
                            :checked="lockChecked"
                            @change="lockChangeEvnt"
                    ></a-checkbox>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row v-if="cfsScanLoad == 'Y'" style="margin-top: 50px;">
                <a-row>
                  <a-col :span="8" offset="1">
                    <a-form-item :label="$t('pubGicSet.CartonNo')">
                      <a-input :disabled="true" style="width: 100%;" size="small" v-model="cartonNo"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8" offset="1">
                    <a-form-item :label="$t('pubGicSet.CartonType')">
                      <a-select show-search optionFilterProp="label" size="small" v-model="cartonType" @change="changeCartonType">
                        <a-select-option :label="item.cartonType"  :value="index" v-for="(item,index) in cartonTypes">{{item.cartonType}}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="5" offset="1">
                    <a-form-item :label="$t('pubGicSet.Length')">
                      <a-input style="width: 100%;" size="small" v-model="cartonLength"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span="5" offset="1">
                    <a-form-item :label="$t('pubGicSet.Width')">
                      <a-input style="width: 100%;" size="small" v-model="cartonWidth"/>
                    </a-form-item>
                  </a-col>
                  <a-col :span="5" offset="1">
                    <a-form-item :label="$t('pubGicSet.Height')">
                      <a-input style="width: 100%;" size="small" v-model="cartonHeight"/>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="8" offset="1">
                    <a-form-item :label="$t('pubGicSet.Weight')">
                      <a-input style="width: 100%;" size="small" v-model="cartonWeight"/>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-row>
            </a-form>
          </a-row>
          <a-row v-if="cfsScanLoad != 'Y'" type="flex" justify="start" style="margin: 10px 0;">
            <a-col style="width: 100%;">
              <p class="scanCodeTile">{{ $t('cfs.scannedQty') }}</p>
              <div class="radius">
                <i :style="{fontSize:setFontSize(this.scannedQty)}">{{ scannedQty }}</i>
              </div>
            </a-col>
          </a-row>
        </a-col>

        <!--右侧-->
        <a-col :span="12" style="float: right">
          <a-row v-if="cfsScanLoad == 'Y'" type="flex" justify="start" style="float: left">
            <a-col style="width: 100%;">
              <p class="scanCodeTile">{{ $t('cfs.scannedQty') }}</p>
              <div class="radius">
                <i :style="{fontSize:setFontSize(this.scannedQty)}">{{ scannedQty }}</i>
              </div>
            </a-col>
          </a-row>
          <a-row>
            <a-form-item v-if="showCounrty"  :label="$t('cfs.destinationCountry')">
              <a-col class="existDataStyle" style="background-color: #00CCFF;">
                <p>{{destinationCountry}}</p>
              </a-col>
            </a-form-item>
          </a-row>
          <a-row>
            <a-form-item v-if="showCourier" :label="$t('cfs.courier')">
              <a-col class="existDataStyle" style="background-color: #6666FF;">
                <p>{{courier}}</p>
              </a-col>
            </a-form-item>
          </a-row>
        </a-col>
      </a-row>
    </a-drawer>

    <audio
            v-if="showSound"
            controls="controls"
            autoplay="autoplay"
            id="loadSound"
            hidden
    >
      <source src="../../../assets/mm.mp3" type="audio/mpeg" />
    </audio>
    <audio
            v-if="showSuccessSound"
            controls="controls"
            autoplay="autoplay"
            id="loadSuccessSound"
            hidden
    >
      <source src="../../../assets/scan_success.mp3" type="audio/mpeg" />
    </audio>

  </div>
</template>
<script>
  import ajax from "../../../api/ajax";
  import api from "../../../api/url";
  import { mapState } from "vuex";
  import moment from "moment";
  import webSocketPrint from "./webSocketPrint";
  import {Modal} from "ant-design-vue";
  import axios from "axios";
  import cookie from "../../../api/cookie";
  import Template from "../reportCom/template";
  export default {
    components: {Template},
    data() {
      return {
        cartonNoDis: false, // sscc 是否可输入
        btnFunArr: [],
        scanFieldTitle: '',
        scanpackDetailTable: [],
        scanpackTabsTarget: '2',
        scanpackDetailAllocatedQty: 0,
        scanpackDetailPackedQty: 0,
        scanpackDetailPercentage: 0,
        scanpackDetailNocarton: 0,
        closeAndNewDisab: true,
        newDisab: false,
        closeDisab: true,
        removeDisab: true,
        appendDisab: true,
        country:'',
        type:'',
        errMsg: "Please new one carton first",
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        cartonSearchVal: "",
        addCortonVisible: false, // New 弹窗
        editForm: this.$form.createForm(this),
        addform: this.$form.createForm(this),
        form: this.$form.createForm(this),
        visible: false,
        copslaShow: true,
        partTable: [], // 父表数据
        cartonTable: [],
        newEditCartData: {},
        tableList:[],//列表数据集合
        editSpin: false, // 编辑加载提示
        selectRow: "", // 父表当前选中行用来样式
        carTonQty: 0, //  carton 显示的number
        carTonOfSku: 0, //  carton 显示的number
//      sku 扫码后换算后的值
        skuPackedQty: 0, // sku 显示num
        skuUnpackQty: 0, // sku 显示num
        Percentage: 0, // sku 显示num
        trackingNumber: "",
        parcelNo: "", // 扫码需要输入的值
        OtySaoNum: 1, // oty 所需要操作数量
        lockChecked: true,
        DeleteChecked: false,
        SkuTableOther: {},
        newType: "",
        tableRelId: '',
        cartonTypeSelectData: [],
        newCartonJson: {},
        scanpackSearchType: '', // so 还是ware 进来
        WareheaderSearchVal: '',
        PrintSsccVal: '',
        scanPackDtoList:[],// 记录扫货次数
        cartonTableXt: [],
        waveUid: null,
        soUid: null,
        trackingNoMap: {},
        destinationCountry:"",
        courier:"",
        showCounrty:false,
        showCourier:false,
        scannedQty:0,
        unScanQty:0,
        showPrintLabel:false,
        collectionTimeFrom:null,
        collectionTimeTo:null,
        consolidationHandling:'ORIGIN',//获取系统参数值
        cfsScanLoad:'',//CFS特殊需求
        mustCollectionTime:'N',//获取系统参数值
        awbMbl:"",
        uldNo:"",
        airLine:"",
        flightNo:"",
        loadingNo:"",
        moreLoading:false,//如果有多个LoadingNo,则不让扫描ParcelNo
        showQuery:true,//是否显示Query按钮,隐藏Reset按钮
        showCreate:true,//是否显示Create Loading按钮,影藏Confirm Loading按钮
        showSound:false,//显示声音控件
        showSuccessSound:false,//显示声音控件
        cartonTypes:[],//箱子类型
        cartonType:'',
        cartonNo:'',
        cartonLength:'',
        cartonWidth:'',
        cartonHeight:'',
        cartonWeight:'',
        localData: {},
        gateWay:"",
        service:"",
        servicesProvider:"",
        skynetPostal:"",
        battery:"",
        printers:[],
      }
    },
    computed: {
      ...mapState(["systemParam"]),
      setFontSize(){
        return function (val) {
          let size = 100;
          val = val + '';
          if(val.length == 1){
            size = 260;
          }else if(val.length == 2){
            size = 220;
          }else if(val.length == 3){
            size = 180;
          }else if(val.length == 4){
            size = 140;
          }
          return size + 'px';
        }
      }
    },
    watch:{

    },
    methods: {
      moment,
//      footer 样式
      footerCellClassName ({ $rowIndex, column, columnIndex }) {
        return 'footerBackColor'
      },
      footerMethod({ columns, data }) {
        let that = this;
        return [
          columns.map((column, columnIndex) => {
            if (["scannedQty"].includes(column.property)) {
              return that.sumPubFn(column.property);
            }
          })
        ];
      },
      sumPubFn(val) {
        let arr = this.tableList;
        let sum = 0;
        for (let index in arr) {
          sum += parseInt(arr[index][val]);
        }
        return sum;
      },
      //            关闭弹窗
      onClose() {
        this.visible = false;
        this.clearTopData();
        this.clearBottomData();
      },
      //            打开弹窗
      show(id,type) {
        this.visible = true
        this.showQuery = true;
        this.showCreate = true;
        this.consolidationHandling = this.systemParam.CONSOLIDATION_HANDLING;
        this.cfsScanLoad = this.systemParam.CFS_SCAN_LOAD;
        this.mustCollectionTime = this.systemParam.MUST_COLLECTION_TIME == undefined || this.systemParam.MUST_COLLECTION_TIME  == null ?'N' : this.systemParam.MUST_COLLECTION_TIME ;
        this.$nextTick(function () {
          this.$refs.relIdRef.focus();
        });
        this.getCartonType();
        this.localData = JSON.parse(sessionStorage.getItem('localData'))//获取下拉框中的值
      },
      clearTopData(){
        this.loadingNo = "";
        this.awbMbl = "";
        this.uldNo = "";
        this.flightNo = "";
        this.collectionTimeFrom = null;
        this.collectionTimeTo = null;
        this.loadingNo = "";
        this.tableList = [];
        this.gateWay = "";
        this.service = "";
        this.servicesProvider = "";
        this.skynetPostal = "";
        this.battery = "";
      },
      clearBottomData(){//清空底部数据
        this.scannedQty = 0;
        this.DeleteChecked = false;
        this.parcelNo = "";
        this.OtySaoNum = 1;
        this.lockChecked = true;
        this.showCounrty = false;
        this.destinationCountry = "";
        this.showCourier = false;
        this.courier = "";
        this.country = ''
        this.type = ''
        this.cartonNo = ''
        this.cartonType = ''
        this.cartonLength = ''
        this.cartonWidth = ''
        this.cartonHeight = ''
        this.cartonWeight = ''
      },
      createLoading(){
        if(this.loadingNo != ''){
          this.$customMessage.warning(this.$t('cfs.resetFirst'),2);
          return;
        }
        if(this.cfsScanLoad == 'Y'){
          if(this.gateWay.length == 0){
            Modal.error({title: this.$t('publicLang.prompt'),content: this.$t('gatewayCannotBeEmpty')});
            return;
          }
          if(this.service.length == 0){
            Modal.error({title: this.$t('publicLang.prompt'),content: this.$t('serviceCannotBeEmpty')});
            return;
          }
          if(this.servicesProvider.length == 0){
            Modal.error({title: this.$t('publicLang.prompt'),content: this.$t('serviceProviderCannotBeEmpty')});
            return;
          }
          if(this.battery.length == 0){
            Modal.error({title: this.$t('publicLang.prompt'),content: this.$t('batteryCannotBeEmpty')});
            return;
          }
          this.createLoadingSpecial();
          return;
        }
        let params = new FormData();
        params.append("awbMbl", this.awbMbl);
        params.append("uldNo", this.uldNo);
        params.append("collectionTimeFrom", this.collectionTimeFrom == null ? '' : moment(this.collectionTimeFrom).format('YYYY-MM-DD HH:mm:ss'));
        params.append("collectionTimeTo", this.collectionTimeTo == null ? '' : moment(this.collectionTimeTo).format('YYYY-MM-DD HH:mm:ss'));
        ajax.post(api.CFSCREATELOADING,params).then(res=>{
          if(res.code == 200){
            this.$message.success(this.$t('cfs.operationSuccess'));
            this.showCreate = false;
            this.showQuery = false;
            this.loadingNo = res.loadingNo;
            this.searchScanLoad();
          }else{
            this.$customMessage.warning(res.msg);
          }
        })
      },
      createLoadingSpecial(){
        let params = new FormData();
        params.append("mawb", this.awbMbl);
        params.append("flightNo", this.flightNo);
        params.append("carrier", this.airLine);
        params.append("gateWay", this.gateWay);
        params.append("service", this.service);
        params.append("servicesProvider", this.servicesProvider);
        params.append("battery", this.battery);
        ajax.post(api.CREATELOADINGSPECIAL,params).then(res=>{
          if(res.code == 200){
            this.$message.success(this.$t('cfs.operationSuccess'));
            this.showCreate = false;
            this.showQuery = false;
            this.loadingNo = res.loadingNo;
            this.searchScanLoad();
          }else{
            Modal.error({title: this.$t('publicLang.prompt'),content: res.msg});
          }
        })
      },
      confirmLoading(){
        if(this.loadingNo == ''){
          this.$customMessage.warning(this.$t('cfs.loadingNo') +" "+ this.$t('job.notNull'),2);
          return;
        }
        if(this.consolidationHandling=='ORIGIN'){
          if(this.awbMbl == ''){
            this.$customMessage.warning((this.cfsScanLoad == 'Y' ? "MAWB#" : this.$t('cfs.awbMbl')) +" "+ this.$t('job.notNull'),2);
            return;
          }
          // if(this.uldNo == ''){
          //   this.$customMessage.warning((this.cfsScanLoad == 'Y' ? "Carrier#" : this.$t('cfs.uldNo')) +" "+ this.$t('job.notNull'),2);
          //   return;
          // }
        }
        if(this.mustCollectionTime == 'Y'){//Collection Time From必填
          if(this.collectionTimeFrom == null){
            this.$customMessage.warning(this.$t('cfs.collectionTimeFrom') + " " + this.$t('job.notNull'),2);
            return;
          }
          if(this.collectionTimeTo == null){
            this.$customMessage.warning(this.$t('cfs.collectionTimeTo') + " " + this.$t('job.notNull'),2);
            return;
          }
        }
        if(this.cfsScanLoad == 'Y'){
          if(this.cartonType.length == 0){
            Modal.error({title: this.$t('publicLang.prompt'),content: this.$t('pubGicSet.CartonType') + " " + this.$t('job.notNull')});
            return;
          }
          if(this.cartonWeight.length == 0){
            Modal.error({title: this.$t('publicLang.prompt'),content: this.$t('pubGicSet.Weight') + " " + this.$t('job.notNull')});
            return;
          }
          if(this.gateWay.length == 0){
            Modal.error({title: this.$t('publicLang.prompt'),content: this.$t('gatewayCannotBeEmpty')});
            return;
          }
          if(this.service.length == 0){
            Modal.error({title: this.$t('publicLang.prompt'),content: this.$t('serviceCannotBeEmpty')});
            return;
          }
          if(this.servicesProvider.length == 0){
            Modal.error({title: this.$t('publicLang.prompt'),content: this.$t('serviceProviderCannotBeEmpty')});
            return;
          }
          if(this.battery.length == 0){
            Modal.error({title: this.$t('publicLang.prompt'),content: this.$t('batteryCannotBeEmpty')});
            return;
          }
        }
        //Confirm Loading之前,执行保存操作
        let params = new FormData();
        params.append("loadingNo", this.loadingNo);
        params.append("awbMbl", this.awbMbl);
        params.append("uldNo", this.uldNo);
        params.append("flightNo", this.flightNo);
        params.append("timeFrom", this.collectionTimeFrom);
        params.append("timeTo", this.collectionTimeTo);
        params.append("type", this.cartonType);
        params.append("length", this.cartonLength.length == 0 ? '0' : this.cartonLength);
        params.append("width", this.cartonWidth.length == 0 ? '0' : this.cartonWidth);
        params.append("height", this.cartonHeight.length == 0 ? '0' : this.cartonHeight);
        params.append("weight", this.cartonWeight.length == 0 ? '0' : this.cartonWeight);
        params.append("gateWay", this.gateWay);
        params.append("service", this.service);
        params.append("servicesProvider", this.servicesProvider);
        params.append("skynetPostal", this.skynetPostal);
        params.append("battery", this.battery);
        ajax.post(api.CFSSAVELOADING,params).then(res=> {
          if (res.code == 200) {
            let params = new FormData();
            params.append("loadingNo", this.loadingNo);
            ajax.post(api.CFSCONFIRMLOADING, params).then(res => {
              if (res.code == 200) {
                this.$message.success(this.$t('cfs.operationSuccess'));
                this.showCreate = true;
                if(this.loadingNo!=null&&this.loadingNo!=""){
                  this.getPrinters();
                  //自动打印
                  params = {
                    loadingNo: this.loadingNo,
                    ip: this.ip
                  };
                  ajax.get(api.AUTOPRINTCFSLOADING,params).then(res => {
                    this.autoPrint(res);
                  })
                }
                if(this.cfsScanLoad != 'Y'){
                  this.clearTopData();
                  this.clearBottomData();
                }
              } else {
                if(this.cfsScanLoad == 'Y'){
                  Modal.error({title: this.$t('publicLang.prompt'),content: res.msg});
                }else{
                  this.$customMessage.warning(res.msg);
                }
              }
            })
          } else {
            if(this.cfsScanLoad == 'Y'){
              Modal.error({title: this.$t('publicLang.prompt'),content: res.msg});
            }else{
              this.$customMessage.warning(res.msg);
            }
          }
        })
      },
      autoPrint(res){
        for (let i = 0; i < res.length; i++) {
          if(res[i]==null){
            continue;
          }
          if (res[i].type == null) {
            continue;
          }
          if(res[i].errorMsg!=null&&res[i].errorMsg!=""){
            continue;
          }
          if(res[i].printerName==null||res[i].printerName==""){
            continue;
          }
          console.log("printerNames:"+res[i].printerName);
          let printerName = "";
          let printerNames = res[i].printerName.split(",");
          for(var j = 0;j<this.printers.length;j++){
            for(var k = 0;k<printerNames.length;k++){
              if(this.printers[j].name==printerNames[k]){
                printerName = printerNames[k];
                break;
              }
            }
            if(printerName!=""&&printerName!=null){
              break;
            }
          }
          console.log("printerName:"+printerName);
          if(printerName!=""){
            res[i].printerName = printerName;
            if(res[i].fileBytes.length>125000){
              let oldFileBytes = res[i].fileBytes;
              let part = Math.ceil(oldFileBytes.length/125000);//分批数
              for (let j = 0; j < part; j++)
              {
                let fileBytes = "";
                if (oldFileBytes.length>125000) {
                  fileBytes = oldFileBytes.substring(0, 125000);
                  oldFileBytes = oldFileBytes.substring(125000, oldFileBytes.lenght);
                } else {
                  fileBytes = oldFileBytes.substring(0, oldFileBytes.lenght);
                  oldFileBytes = "";
                }
                res[i].fileIndex = j;//当前发送位置
                res[i].fileCount = part;//表示发送多次已发完
                res[i].fileBytes = fileBytes;
                webSocketPrint.doPrint("9999",JSON.stringify(res[i]));
              }
            }else{
              res[i].fileCount = 1;//1表示一次发完
              webSocketPrint.doPrint("9999",JSON.stringify(res[i]));
            }
          }
        }
      },
      saveLoading(){
        let params = new FormData();
        params.append("loadingNo", this.loadingNo);
        params.append("awbMbl", this.awbMbl);
        params.append("uldNo", this.uldNo);
        params.append("flightNo", this.flightNo);
        params.append("timeFrom", this.collectionTimeFrom);
        params.append("timeTo", this.collectionTimeTo);
        params.append("type", this.cartonType);
        params.append("length", this.cartonLength.length == 0 ? '0' : this.cartonLength);
        params.append("width", this.cartonWidth.length == 0 ? '0' : this.cartonWidth);
        params.append("height", this.cartonHeight.length == 0 ? '0' : this.cartonHeight);
        params.append("weight", this.cartonWeight.length == 0 ? '0' : this.cartonWeight);
        params.append("gateWay", this.gateWay);
        params.append("service", this.service);
        params.append("servicesProvider", this.servicesProvider);
        params.append("skynetPostal", this.skynetPostal);
        params.append("battery", this.battery);
        ajax.post(api.CFSSAVELOADING,params).then(res=>{
          if(res.code == 200){
            this.$message.success(this.$t('cfs.operationSuccess'));
            this.searchScanLoad();
          }else{
            this.$customMessage.warning(res.msg);
          }
        })
      },
      copyLoading(){
        let params = new FormData();
        params.append("awbMbl", this.awbMbl);
        params.append("uldNo", this.uldNo);
        params.append("flightNo", this.flightNo);
        params.append("gateWay", this.gateWay);
        params.append("service", this.service);
        params.append("servicesProvider", this.servicesProvider);
        params.append("skynetPostal", this.skynetPostal);
        params.append("battery", this.battery);
        ajax.post(api.CFSCOPYLOADING,params).then(res=>{
          if(res.code == 200){
            this.loadingNo = res.loadingNo == null ? '' : res.loadingNo;
            this.searchScanLoad();
            this.$message.success(this.$t('cfs.operationSuccess'));
          }else{
            this.$customMessage.warning(res.msg);
          }
        })
      },
      reset(){
        this.clearTopData();
        this.clearBottomData();
        this.showCreate = true;
        this.showQuery = true;
      },
      searchScanLoad(){
        if(this.consolidationHandling=='ORIGIN'){
          if(this.awbMbl == '' && this.uldNo == '' && this.loadingNo == ''){
            this.$customMessage.warning(this.$t('cfs.awbMbl') + " / " +  this.$t('cfs.uldNo') +" / "+ this.$t('cfs.loadingNo') +" "+ this.$t('job.notNull'),2);
            return;
          }
        }else{
          if(this.loadingNo == ''){
            this.$customMessage.warning(this.$t('cfs.loadingNo') +" "+ this.$t('job.notNull'),2);
            return;
          }
        }
        let params = new FormData();
        params.append("awbMbl", this.awbMbl);
        params.append("uldNo", this.uldNo);
        params.append("flightNo", this.flightNo);
        params.append("loadingNo", this.loadingNo);
        params.append("gateWay", this.gateWay);
        params.append("service", this.service);
        params.append("servicesProvider", this.servicesProvider);
        ajax.post(api.CFSSCANLOADSEARCHSCANLOAD,params).then(res=>{
          if(res.code == 200){
            if(this.cfsScanLoad == 'Y'){
              this.country = res.country
              this.type = res.type
            }
            this.tableList = res.data;
            this.scannedQty = 0;
            this.moreLoading = res.moreLoading;
            this.showQuery = false;
            this.showCreate = false;//查出数据则显示Confirm按钮
            for (let index in res.data) {//统计已扫描数量
              this.scannedQty += parseInt(res.data[index]['scannedQty']);
              if(res.data[index]['ediSendFlag'] == 'Y'){
                this.showCreate = true;
              }
            }
            this.awbMbl = res.awbMbl;
            this.uldNo = res.uldNo;
            this.flightNo = res.flightNo;
            this.loadingNo = res.loadingNo == null ? '' : res.loadingNo;
            this.gateWay = res.gateWay;
            this.service = res.service;
            this.servicesProvider = res.servicesProvider;
            this.skynetPostal = res.skynetPostal;
            this.battery = res.battery;
            this.collectionTimeFrom = res.collectionTimeFrom;
            this.collectionTimeTo = res.collectionTimeTo;
            if(res.destinationCountry != null && res.destinationCountry.length > 0){
              this.showCounrty = true;
              this.destinationCountry = res.destinationCountry;
            }else{
              this.showCounrty = false;
            }
            if(res.courier != null && res.courier.length > 0){
              this.showCourier = true;
              this.courier = res.courier;
            }else{
              this.showCourier = false;
            }

            this.cartonNo = res.cartonNo
            this.cartonType = res.cartonType
            this.cartonLength = res.cartonLength == 0 ? '' : res.cartonLength
            this.cartonWidth = res.cartonWidth == 0 ? '' : res.cartonWidth
            this.cartonHeight = res.cartonHeight == 0 ? '' : res.cartonHeight
            this.cartonWeight = res.cartonWeight == 0 ? '' : res.cartonWeight
          }else{
            this.$customMessage.warning(res.msg);
          }
        })
      },
      getCartonType(){
        ajax.get(api.CFSGETALLCARTONTYPE).then(res => {
          if(res.code == 200){
            this.cartonTypes = res.data
          }
        })
      },
      changeCartonType(value){
        let cartonTypes = this.cartonTypes[value];
        this.cartonType = cartonTypes.cartonType
        this.cartonLength = cartonTypes.length
        this.cartonWidth = cartonTypes.width
        this.cartonHeight = cartonTypes.height
      },
      //Enter事件
      parcelNoEnterEvt() {
        if(this.parcelNo.length == 0){
          this.$customMessage.warning(this.$t('cfs.parcelNo') +" "+ this.$t('job.notNull'),3);//不能为空
          return;
        }
        if(!this.lockChecked){//如果没有选中Lock Scan Qty,则光标跳转到Qty输入框
          this.$refs.SacnPackSaomaQtyNum.focus()
        }else{
          if(this.cfsScanLoad == 'Y'){
            if(!this.DeleteChecked && this.service == 'UNTRACKED' && this.skynetPostal.length == 0){
              this.$customMessage.warning(this.$t('skynetPostal') +" "+ this.$t('job.notNull'),3);//不能为空
              return;
            }
          }
          this.scanParcelNo();
        }
      },
      qtyEnterEvt() {
        if(this.parcelNo.length == 0){
          this.$customMessage.warning(this.$t('cfs.parcelNo') +" "+ this.$t('job.notNull'),3);//不能为空
          return;
        }
        if(this.OtySaoNum < 1){
          this.$customMessage.warning(this.$t('pubGicSet.Qty') +" "+ this.$t('pubGicSet.QtyRequired'),3);//数量
          return;
        }
        this.scanParcelNo();
      },
      scanParcelNo(){
        let params = new FormData();
        params.append("loadingNo", this.loadingNo);
        params.append("parcelNo", this.parcelNo);
        params.append("qty", this.OtySaoNum);
        params.append("removeScanItem", this.DeleteChecked);
        params.append("skynetPostal", this.skynetPostal);
        ajax.post(api.CFSLOADPARCELNO,params).then(res=>{
          if(res.code == 200){
            this.audioSuccessPubFun();
            this.parcelNo = "";
            if(this.cfsScanLoad == 'Y'){
              this.country = res.country
              this.type = res.type
            }else{
              this.destinationCountry = res.data.destinationCountry;
              if(this.destinationCountry != null && this.destinationCountry.length > 0){
                this.showCounrty = true;
              }
              this.courier = res.data.courier;
              if(this.courier != null && this.courier.length > 0){
                this.showCourier = true;
              }
            }
            this.DeleteChecked = false;
            this.searchScanLoad();
          }else{
            if(this.cfsScanLoad == 'Y'){
              Modal.error({title: this.$t('publicLang.prompt'),content: res.msg});
            }else{
              this.$customMessage.warning(res.msg);
            }
            this.audioPubFun();//播放声音
          }
        })
      },
      //            播放提示声
      audioPubFun() {
        this.showSound = true;
        let audio = document.getElementById("loadSound");
        if (audio !== null) {
          if (audio.paused) {
            audio.play();
          } else {
            audio.pause();
          }
        }
      },
      audioSuccessPubFun() {
        this.showSuccessSound = true;
        let audio = document.getElementById("loadSuccessSound");
        if (audio !== null) {
          if (audio.paused) {
            audio.play();
          } else {
            audio.pause();
          }
        }
      },
      //            lock扫码数量事件
      lockChangeEvnt(e) {
        this.lockChecked = !this.lockChecked;
        if(!this.lockChecked){
          this.$refs.SacnPackSaomaQtyNum.focus()
          this.OtySaoNum = null
        }else{
          this.OtySaoNum = 1
        }
      },
      //            回退扫码数量
      DeleteChangeEvnt() {
        this.DeleteChecked = !this.DeleteChecked;
        this.lockChecked = true
        this.OtySaoNum = 1
      },
      //            表格样式
      cellClassName({ row }) {
        if (row === this.selectRow) {
          return "col-orange";
        }
      },
      rowStyle ({ row }) {
        if(row.sscc == '*'){
          return {
            color: 'red'
          }
        }
      },
      changeCollectionTimeFrom(val){
        this.collectionTimeFrom = moment(val).format('YYYY-MM-DD HH:mm:ss');//时间控件选择时间后会改成时间对象,所以需要转成我们需要的时间字符串
        if(this.collectionTimeFrom >= this.collectionTimeTo){
          this.collectionTimeTo = "";//如果选择的TimeFrom大于TimeTo,就将TimeTo清空
        }
      },
      changeCollectionTimeTo(val){
        this.collectionTimeTo = moment(val).format('YYYY-MM-DD HH:mm:ss');//时间控件选择时间后会改成时间对象,所以需要转成我们需要的时间字符串
        if(this.collectionTimeTo <= this.collectionTimeFrom){//如果选择的TimeTo小于TimeFrom,就将TimeFrom清空
          this.collectionTimeTo = null;
        }
      },
      disabledDateFrom(current) {
        return current < moment().startOf('minute');//精确到分钟不可选
      },
      disabledDateTo(current) {
        return current < moment().startOf('minute');
      },
      // 获取用户本地ip的方法
      getUserIP (onNewIP) {
        let MyPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection
        let pc = new MyPeerConnection({
          iceServers: []
        })
        let noop = () => {

        }
        let localIPs = {}
        let ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g
        let iterateIP = (ip) => {
          if (!localIPs[ip]) onNewIP(ip)
          localIPs[ip] = true
        }
        pc.createDataChannel('')
        pc.createOffer().then((sdp) => {
          sdp.sdp.split('\n').forEach(function (line) {
            if (line.indexOf('candidate') < 0) return
            line.match(ipRegex).forEach(iterateIP)
          })
          pc.setLocalDescription(sdp, noop, noop)
        }).catch((reason) => {
        })
        pc.onicecandidate = (ice) => {
          if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return
          ice.candidate.candidate.match(ipRegex).forEach(iterateIP)
        }
      },
      printViewPdf(){
        let ajaxurl = ajax.ajaxUrl();
        let params = {
          palletNo: this.loadingNo
        }
        let that = this
        axios.get(ajaxurl + api.PRINTPREVIEWREPORT, {
          params,
          headers: {
            Authorization: cookie.getBearerToken()
          },
          responseType: "blob" //二进制流
        }).then(res=>{
          that.pubPdfMsgfn(res);
        });
      },
      // paf接口返回值处理
      pubPdfMsgfn(res){
        let data = res.data;
        let fileReader = new FileReader();
        let that = this
        fileReader.onload = function() {
          try {
            let jsonData = JSON.parse(this.result);
            if (jsonData.code) {
              that.$customMessage.warning(jsonData.msg);
              that.$store.commit("updataLoading", { pbLoading: false });
            }
          } catch (err) {
            that.pubPdfUploadOk(res)
          }
        };
        fileReader.readAsText(data)
      },
      //pdf 成功下载方法
      pubPdfUploadOk(data){
        this.$store.commit("updataLoading", { pbLoading: false });
        let blob = new Blob([data.data], {type: "application/pdf;charset=utf-8"});
        let url = window.URL.createObjectURL(blob);
        window.open(url);
      },
      getPrinters(){
        let that = this;
        if ("WebSocket" in window)
        {
          // Create websocket
          var ws = new WebSocket("ws://localhost:9999/print");
          ws.onopen = function()
          {
            ws.send("{'Type':'SERVER_INFO'}");
          };
          ws.onmessage = function (evt)
          {
            var msg = evt.data;
            try {
              that.printers = JSON.parse(msg).printerServer.printers;
            } catch (e) {
            }
          };
          ws.onclose = function()
          {

          };
        }
        else
        {

        }
      },
    },
    mounted(){
      this.getUserIP((ip) => {
        this.ip = ip;
      });
      this.getPrinters();
    }
  };
</script>
<style lang="less">
  .ant-btn-group > .ant-btn:first-child:not(:last-child), .ant-btn-group > span:first-child:not(:last-child) > .ant-btn {
    border: 0px;
  }

  .ant-dropdown-button>.ant-btn-default{
    padding: 0 7px;
    font-size: 14px;
    border-radius: 4px;
    height: 24px;
  }
  .ant-advanced-search-form .ant-form-item {
    display: flex;
  }

  .ant-advanced-search-form .ant-form-item-control-wrapper {
    flex: 1;
  }

  #components-form-demo-advanced-search .ant-form {
    max-width: none;
  }
  #components-form-demo-advanced-search .search-result-list {
    margin-top: 16px;
    border: 1px dashed #e9e9e9;
    border-radius: 6px;
    background-color: #fafafa;
    min-height: 200px;
    text-align: center;
    padding-top: 80px;
  }
  .scanCodeTile {
    font-size: 16px;
    text-align: center;
  }
  .radius {
    background: #009900;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 330px;
    height: 330px;
    margin: 0 auto;
    border-radius: 50%;
    i {
      color: #fff;
    }
  }
  .scanpackHeader {
    display: flex;
    align-items: center;
    justify-content: left;
  }
  .searchTitle {
    font-size: 12px;
    margin: 0 10px;
    width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: right;
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
  }
  .slide-fade-enter-active {
    transition: all 0.1s ease;
  }
  .slide-fade-leave-active {
    transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }

  .mytable-style .vxe-body--row.row-green {
    background-color: darkseagreen;
    color: #333;
  }
  .existDataStyle{
    width: 80%;
    height: 120px;
    margin-top: 5px;
    padding-top: 40px;
    text-align: center;
    color: white;
    font-size: 100px;
  }
  .noDataStyle{
    width: 80%;
    height: 120px;
    margin-top: 5px;
    padding-top: 40px;
  }
</style>
